<template>
  <div
    class=main--text>
    <v-lp-tool-bar/>
    <v-container
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=8>
          <v-row>
            <v-col><h1>授業フィードバック</h1></v-col>
          </v-row>
          <v-card>
            <v-container
              fluid>
              <v-row>
                <v-col>
                  <h2>基本情報</h2>
                </v-col>
              </v-row>
              <v-row
                no-gutters>
                <v-col
                  cols=12
                  md=6>
                  <v-list
                    two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>日時</v-list-item-subtitle>
                        <v-list-item-title>2020/01/20 18:00-19:00</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>生徒氏名／学年</v-list-item-subtitle>
                        <v-list-item-title>渋谷太郎／小５</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>担当</v-list-item-subtitle>
                        <v-list-item-title>新宿花子</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols=auto><h2>満足度チャート</h2></v-col>
              </v-row>
              <v-row>
                <v-col
                  cols=12
                  md=12>
                  <v-sheet
                    elevation="4"
                    color="light-blue">
                    <v-sparkline
                      :labels="labels"
                      :value="values"
                      show-labels
                      auto-draw
                      smooth=2
                      color="white"
                      line-width=2
                      />
                  </v-sheet>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols=auto>
                  <h2>気持ちグラフ</h2>
                </v-col>
              </v-row>
              <v-row
                >
                <v-col
                  cols=12
                  md=6>
                  <v-container
                    fulid>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <h3>喜んでいた</h3>
                      </v-col>
                    </v-row>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <v-progress-circular
                          rotate="-90"
                          size=150
                          width=16
                          value=78
                          color=green
                        >
                          <span
                            class="display-1 font-weight-bold">78</span>
                        </v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col>
                  <v-container
                    fluid>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <h3>驚いていた</h3>
                      </v-col>
                    </v-row>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <v-progress-circular
                          rotate="-90"
                          size=150
                          width=16
                          value=32
                          color=red
                        >
                          <span
                            class="display-1 font-weight-bold">32</span>
                          </v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=12
                  md=6>
                  <v-container
                    fluid>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <h3>落ち着いていた</h3>
                      </v-col>
                    </v-row>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <v-progress-circular
                          rotate="-90"
                          size=150
                          width=16
                          value=89
                          color=green
                        >
                          <span
                            class="display-1 font-weight-bold">89</span>
                          </v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col
                  cols=12
                  md=6>
                  <v-container
                    fluid>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <h3>元気だった</h3>
                      </v-col>
                    </v-row>
                    <v-row
                      justify=center>
                      <v-col
                        cols=auto>
                        <v-progress-circular
                          rotate="-90"
                          size=150
                          width=16
                          value=19
                          color=red
                        >
                          <span
                            class="display-1 font-weight-bold">19</span>
                          </v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-lp-footer></v-lp-footer>
  </div>
</template>

<script>
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
import VLpFooter from '@/components/organisms/lp/VLpFooter.vue'

export default {
  components: {
    VLpToolBar,
    VLpFooter
  },
  data: () => {
    return {
      labels: [
        '5',
        '10',
        '15',
        '20',
        '25',
        '30',
        '35',
        '40',
        '45',
        '50',
        '55',
        '60'
      ],
      values: [
        1.2,
        2.7,
        0.8,
        0.6,
        1.0,
        1.3,
        1.0,
        1.8,
        2.6,
        2.8,
        3.0,
        4.5
      ]
    }
  }
}
</script>

<style scoped>

</style>